import { Controller } from "stimulus";

export default class extends Controller
{
    static targets = [
        "input", "search", "loading", "advanced", "parameters", "results", "clear"
    ]

    connect()
    {
        this.advancedTarget.addEventListener("click", e =>
        {
            if(this.advancedTarget.classList.contains("active"))
            {
                this.advancedTarget.classList.remove("active");
                this.parametersTarget.classList.add('hidden');
                this.clearTarget.classList.add("hidden");
                this.inputTarget.disabled = false;
            }
            else
            {
                this.advancedTarget.classList.add("active");
                this.parametersTarget.classList.remove('hidden');
                this.clearTarget.classList.remove("hidden");
                this.inputTarget.disabled = true;
            }
        })

        this.clearTarget.addEventListener("click", e =>
        {
            let inputs = this.parametersTarget.querySelectorAll("input");
            inputs.forEach(input => input.value = null);
        })

        this.inputTarget.addEventListener("keydown", e =>
        {
            if(e.key == "Enter" && this.inputTarget.value)
            {
                this.searchTarget.click();
            }
        })

        this.searchTarget.addEventListener("click", e =>
        {

            if(!this.inputTarget.disabled && !this.inputTarget.value) return;
            let data = {};

            if(this.advancedTarget.classList.contains("active"))
            {
                let formData = new FormData(this.parametersTarget);
                formData = Array.from(formData).filter(x => x[1]);

                formData.forEach(x => data[x[0]] = x[1]);
                data.type = "adv"
            }
            else
            {
                data.q = this.inputTarget.value;
            }

            this.searchTarget.classList.add("hidden");
            this.loadingTarget.classList.remove("hidden");
            // this.resultsTarget.classList.add("hidden");

            fetch(window.App.prefixedUrl("/search"),
            {
                method: "POST",
                body: JSON.stringify(data),
                headers: { "content-type": "application/json" }
            })
            .then(res => res.text())
            .then(html =>
            {
                if(data.q)
                {
                    window.history.pushState({page: "search-simple"}, `Search for "${data.q} | usadealer.us"`, window.App.prefixedUrl(`/search?q=${data.q}`))
                    document.title = `Search for "${data.q}" | usadealer.us`
                }
                else
                {
                    let params = Object.entries(data);
                    let res = params.map(p => `${p[0]}=${encodeURIComponent(p[1])}`).join("&");

                    window.history.pushState({page: "search-advanced"}, `Advanced Search | usadealer.us`, window.App.prefixedUrl(`/search?${res}`));
                    document.title = `Advanced Search | usadealer.us`
                }

                this.resultsTarget.innerHTML = html;

                this.searchTarget.classList.remove("hidden");
                this.loadingTarget.classList.add("hidden");
                this.resultsTarget.classList.remove("hidden");
            })
            .catch(e =>
            {
                let event = new CustomEvent("show-toast", { detail: "An error occurred, please try again." });
                window.dispatchEvent(event);
            })
            .finally(() =>
            {
                this.loadingTarget.classList.add("hidden");
                this.searchTarget.classList.remove("hidden");
            })
            
        })
    }
}